import script from "./TaskFollowupModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./TaskFollowupModal.vue?vue&type=script&setup=true&lang=ts"

import "./TaskFollowupModal.vue?vue&type=style&index=0&id=13d848d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13d848d0"]])

export default __exports__